import { useContext } from 'react';
import { ReportStaticTextsContext } from '../contexts/ReportStaticTextsContext';

export const useReportStaticTexts = () => {
  const context = useContext(ReportStaticTextsContext);
  if (!context) {
    throw new Error('useReportStaticTexts must be used within ReportStaticTextsProvider');
  }
  return context;
};
